import { Aspect } from '@teambit/harmony';

export const RenamingAspect = Aspect.create({
  id: 'teambit.component/renaming',
});
